<template>
  <div>
    <h1 class="text-center">
      {{ schema.$title }}
    </h1>

    <panel :title="schema.data.tenderer.$title" :is-pesel-field="false" :is-phone-number-field="false">
      <employer :model="schema.data.tenderer" />
    </panel>

    <panel :title="schema.data.employee.$title">
      <employee :model="schema.data.employee" :type-of-profesion="typeOfProfesion" />
    </panel>

    <panel>
      <div class="row form-group">
        <div class="col-12">
          <span>
            {{ schema.data.personalDataStatement.$title }}
          </span>

          <yes-or-no class="mt-2" title :model="schema.data.personalDataStatement" />
        </div>
      </div>
    </panel>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Panel from '@/components/panel/Panel.vue';
import { ow004Mixin } from '@/mixins/document/ow004';
import { replacePlaceholdersMixin } from '@/mixins/replacePlaceholders';

import Employee from '../Employee.vue';
import Employer from '../Employer.vue';
import YesOrNo from '../YesOrNoRadio';

// @vuese
// Formularz wzoru zawiadomienia do OW-004
export default {
  components: {
    Employee,
    Employer,
    Panel,
    YesOrNo,
    ...components
  },
  mixins: [ow004Mixin, replacePlaceholdersMixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true }
  }
};
</script>
